import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

const REALTIME_BASE = `${BASE_URL}realtime/`;

export async function exchangeRealtimeCookie() {
  const r = await fetch(`${REALTIME_BASE}auth/exchange/`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeader(),
    },
    body: "{}",
  });
  if (!r.ok) {
    throw new Error(`exchange failed: ${r.status}`);
  }
  return r.json();
}

export function openTestStream({
  onPing,
  onMessage,
  onHistory,
  onOpen,
  onError,
} = {}) {
  // EventSource no puede enviar headers personalizados, así que pasamos el
  // token DRF como query string. Es un fallback para navegadores que
  // bloquean third-party cookies (Chrome/Firefox/Safari con "Block
  // third-party cookies"). El backend acepta cookie, header o ?token=.
  const token = localStorage.getItem("token") || "";
  const qs = token ? `?token=${encodeURIComponent(token)}` : "";
  const es = new EventSource(`${REALTIME_BASE}test-sse/stream/${qs}`, {
    withCredentials: true,
  });
  es.addEventListener("ping", (e) => {
    try {
      onPing?.(JSON.parse(e.data));
    } catch {
      onPing?.(e.data);
    }
  });
  es.addEventListener("history", (e) => {
    try {
      onHistory?.(JSON.parse(e.data));
    } catch {
      onHistory?.(e.data);
    }
  });
  es.onmessage = (e) => {
    try {
      onMessage?.(JSON.parse(e.data));
    } catch {
      onMessage?.(e.data);
    }
  };
  es.onopen = () => onOpen?.();
  es.onerror = (e) => onError?.(e);
  return es;
}

export async function triggerTestEvent({ mensaje, usuario }) {
  // Para POST sí podemos enviar headers: mandamos Authorization además de
  // confiar en la cookie. Si el navegador bloquea la cookie, el header
  // sigue llegando y el backend lo acepta (ver _resolve_user).
  const r = await fetch(`${REALTIME_BASE}test-sse/trigger/`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify({ mensaje, usuario }),
  });
  if (!r.ok) {
    throw new Error(`trigger failed: ${r.status}`);
  }
  return r.json();
}